// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import styles from './styles.module.scss';

type Props = {
  name: string,
  to?: string,
  children?: React$Node,
  className?: string,
  classNameChildren?: string,
  use?: string,
  icon?: any,
  onClick?: () => void,
}

const CustomLink = ({
  name,
  to = '/',
  children,
  className,
  classNameChildren,
  use = 'primary',
  icon,
  onClick,
}: Props) => (
  // eslint-disable-next-line max-len
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
  <div onClick={onClick} className={styles.container}>
    { icon && <img src={icon} alt={`${icon}`} /> }
    <Link
      to={to}
      className={classnames(styles.customLink, styles[use], className)}
    >
      <div className={classnames(styles.customLinkText, classNameChildren)}>
        {children || name}
      </div>
    </Link>
  </div>
);

export default CustomLink;
